import styles from './index.css';

import * as React from 'react';

import {getLabel} from '../../Config/labels';

export default () => (
    <div className={styles.spinner}>
        {getLabel('IS_FETCHING')}
    </div>
)
